import script from "./date-toggle.vue?vue&type=script&setup=true&lang=ts"
export * from "./date-toggle.vue?vue&type=script&setup=true&lang=ts"

import "./date-toggle.vue?vue&type=style&index=0&id=905bcc1c&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-905bcc1c"]])

export default __exports__